enum TokenKeyTypes {
  'USER_TOKEN' = 'user_token',
  'REFRESH_TOKEN' = 'refresh_token',
  'AUTH_TOKEN' = 'auth_token',
  'ACCESS_TOKEN' = 'access_token',
}

export default TokenKeyTypes;
